import script from "./itemImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./itemImage.vue?vue&type=script&setup=true&lang=ts"

import "./itemImage.vue?vue&type=style&index=0&id=6632ab7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6632ab7e"]])

export default __exports__